import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyArs',
})
export class CurrencyArsPipe implements PipeTransform {
  transform(value: number | string, args?: any[]): any {
    if (!value) {
      if (args && args.length && args[1] !== undefined && args[1] !== null && args[1] === 'last') {
        return `0 ${args[0]}`;
      } else {
        return `$ 0`;
      }
    }

    if (typeof value === 'number') {
      if (value % 1 === 0) {
        value = value.toString() + '.00';
      } else {
        value = value.toString();
      }
    }

    if (value.toString().includes('$')) {
      return value;
    }

    const arr = value.split('.');
    if (arr.length > 1) {
      arr[1] = arr[1].substr(0, 2);
    }
    arr[0] = arr[0]
      .split('')
      .reverse()
      .join('')
      .match(/.{1,3}/g)
      .join('.')
      .split('')
      .reverse()
      .join('');

    let coin = '$';
    let response = '';

    if (args && args.length && args[0]) {
      coin = args[0];
    }
    if (args && args.length && args[1] !== undefined && args[1] !== null && args[1] === 'last') {
      response = `${arr.join(',')} ${coin}`;
    } else {
      response = `${coin} ${arr.join(',')}`;
    }
    return response;
  }
}
